import React, { useState, useEffect } from "react";
import { cloneDeep } from "lodash";
import { ToastContainer } from "react-toastify";
import { Card, CardBody, Container } from "reactstrap";

import useAxios from "hooks/useAxios";
import ErrorBoundary from "components/ErrorBoundary";
import useContextService from "hooks/useContextService";
import SearchContainer from "./components/SearchContainer";
import { onExport, getUpdatedFilterLatest } from "utils/helper";
import ClaimsManagerTable from "./components/ClaimsManagerTable";
import Drawer from "components/Drawer";
import BulkUpdateClaims from "components/BulkUpdateClaims";
import PatientNotFound from "components/PatientNotFound";
import PatientProviderMap from "components/PatientProviderMap";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import Loader from "components/Loader";
import Patient from "pages/Patient";

let filters = [];

const ClaimManager = (props) => {
  const { module, onbulkupdate, selectstatus, orgId, } = props;

  const API = useAxios();
  const [data, setData] = useState([]);
  const [totalItem, setTotalItem] = useState(0);
  const {
    states: { claimsManager },
    setStates,
  } = useContextService();
  console.log(data, "claimMangerdata");

  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [bulkupdate, setBulkUpdate] = useState(false);
  const [openPatient, setOpenPatient] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [columnFilters, setcolumnFilters] = useState([]);
  const { search, coveredEntity, searchTerms, claimStatusID } = claimsManager;
  const { tenantID } = coveredEntity;
  const { coveredEntityID } = coveredEntity;;
  const [patientdata, setPatientData] = useState({});
  const [patientTableData, setPatientTableData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpenProgram, setOpenProgram] = useState(false);
  const [isPEmty, setIsPEmpty] = useState(null);
  const [ispatntEmpty, setIspatntEmpty] = useState(null);
  const [showpatientdetails, setShowPatientDetails] = useState(false)
  const [patientIDNAME, setPatientIdName] = useState("")
  const [resetFlag, SetResetFlag] = useState(false);


  useEffect(() => {
    fetchBulkData();
  }, []);

  useEffect(() => {
    if (searchTerms.coveredEntityID) handleSearch(searchTerms);
  }, []);

  const fetchBulkData = async () => {
    try {
      setLoader(true);
      const { data } = await API.post(`/${tenantID}/Claim/Allclaims/`, search, {
        hideLoader: true,
      });
      setTableData(data);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };

  const manvalPatient = (rowdata) => {
    setPatientTableData([]);
    setPatientData(rowdata);
    fetchPatientmaplist(rowdata);
    setOpenPatient(!openPatient);
  };
  const onHandleManualProgram = () => {
    setOpenProgram(!isOpenProgram);
  };

  const togglepatient = () => {
    setOpenPatient(!openPatient);
  };
  const fetchStatusData = async (claimstsId) => {
    try {
      const { data } = await API.get(
        "RCMConfig/TypeStatus/AllowedClaimStatus/" + claimstsId,
        {
          hasDefaultURL: true,
        }
      );

      if (data) {
        setStatusList(data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const onManualSearch = () => {
    setOpenProgram(true);
  };
  const fetchClaimList = async (filters) => {
    setLoading(true)
    if (!tenantID) {
      setLoading(false)
      return null;
    }
    try {
      const { data } = await API.post(`/${tenantID}/Claim/All`, filters);
      if (data) {
        setData(data.items);

        setTotalItem(data.totalRecords);
        setLoading(false)

      } else {
        setData([]);
        setTotalItem(0);
        setLoading(false)

      }
    } catch (error) {
      setLoading(false)

    }
  };

  const handleExport = async () => {
    const { access_token } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Claim/ExportAll?access_token=${access_token}`;
    onExport(action, search);
  };

  const handleExport2 = async () => {
    const filterObj = cloneDeep(search);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.CEId = coveredEntityID;
    //filterObj.CoveredEntityIDS = coveredEntityID;
    var payload = {};
    payload.tenantID = tenantID;
    payload.gridCode = "claimsmanager";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };


  const handleSearch = async (filter, claimstsId) => {
    const {
      pharmacyID,
      pharmacyIDs,
      claimstatusIDs,
      claimStatusID,
      patientID,
      rxNumber,
      coveredEntityID,
      providerNPI,
      startDate,
      endDate,
      providerID,
    } = filter;
    Object.keys(filter).map((key) => {

      const index = filters.findIndex(
        (item) => item.filterName === key && key != "dateofservice"
      );
      filters.splice(index, 1);
    });
    if (coveredEntityID) {
      filters = getUpdatedFilterLatest(
        "coveredEntityID",
        parseInt(coveredEntityID),
        filters
      );
    }
    if (ispatntEmpty != "") {
      if (patientID) {
        filters = getUpdatedFilterLatest("patientID", patientID, filters);
      }
    }
    if (rxNumber) {
      filters = getUpdatedFilterLatest("rxNumber", rxNumber.trim(), filters);
    }
    if (isPEmty != "") {
      if (providerNPI || providerID) {
        filters = getUpdatedFilterLatest(
          "providerID",
          providerNPI || providerID,
          filters
        );
      }
    }
    if (startDate) {
      filters = getUpdatedFilterLatest(
        "dateofservice",
        startDate,
        filters,
        "startDate"
      );
    }
    if (endDate) {
      filters = getUpdatedFilterLatest(
        "dateofservice",
        endDate,
        filters,
        "endDate"
      );
    }
    var pIds = [];
    if (
      pharmacyIDs === undefined &&
      searchTerms.pharmacyIds.length !== undefined &&
      searchTerms.pharmacyIds.length > 0
    ) {
      pIds = filter.pharmacyIds.map((item) => item["value"]);
    } else {
      pIds = pharmacyIDs;
    }
    var cids = [];
    if (
      claimstatusIDs === undefined &&
      searchTerms.claimStatusIds.length !== undefined &&
      searchTerms.claimStatusIds.length > 0
    ) {
      cids = filter.claimStatusIds.map((item) => item["value"]);
    } else {
      cids = claimstatusIDs;
    }
    const tableRes = document.querySelector(".table-responsive");
    tableRes.scrollLeft = 0;
    search.filters = filters;
    search.pharmacyIDs = pIds;
    search.claimstatusIDs = cids;
    if (coveredEntityID) {
      await fetchClaimList(search);

    }
    if (claimstsId != undefined) fetchStatusData(claimstsId);
  };

  const refetch = (hasReset) => {
    // handleSearch(searchTerms);
    // setcolumnFilters([]);
    if (hasReset) {
      claimsManager.search.currentPage = 1;
      claimsManager.search.pageSize = search.pageSize;
      setcolumnFilters([]);
      setStates("claimsManager", claimsManager);
      handleSearch(searchTerms);
    }
  };

  const toggleBulkUpdate = () => {
    setBulkUpdate(!bulkupdate);
    setTableData([]);
  };
  const onManualbulkUpdate = async () => {
    setBulkUpdate(true);
    fetchBulkData();
  };

  const handlePageChange = (filter, haveColFilter) => {
    if (haveColFilter) {
      const filterObj = cloneDeep(search);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;
      filterObj.orderBy = filter.orderBy;
      filterObj.order = filter.order;
      claimsManager.search.currentPage = filter.currentPage;
      claimsManager.search.pageSize = filter.pageSize;
      claimsManager.search.order = filter.order;
      claimsManager.search.orderBy = filter.orderBy;
      claimsManager.search = { ...claimsManager.search };
      fetchClaimList(filterObj);
    } else {
      fetchClaimList(filter);
      claimsManager.search = { ...claimsManager.search, ...filter };
    }
    setStates("claimsManager", claimsManager);
  };

  const handleReset = () => {
    setData([]);
    claimsManager.search = {
      currentPage: 1,
      pageSize: 10,
      order: "desc",
      orderBy: "ceReceivable",
      filters: [],
    }
    setTotalItem(0);
    claimsManager.coveredEntity = {};
    claimsManager.searchTerms.coveredEntityID = "";
    claimsManager.searchTerms.pharmacyIds = {};
    // filters = []
    SetResetFlag(true);
  };

  useEffect(() => {
    handleReset()
    claimsManager.coveredEntity = {};
    claimsManager.searchTerms.coveredEntityID = "";
    if (bulkupdate == true) {
      toggleBulkUpdate()
    }
    if (openPatient == true) {
      togglepatient()
    }
    if (isOpenProgram == true) {
      onHandleManualProgram()
    }
    setShowPatientDetails(false)
    claimsManager.patient = ""
    claimsManager.searchTerms.rxNumber = "";
    claimsManager.provider = "";
    searchTerms.providerID = "";
    claimsManager.searchTerms.patientID = "";

    claimsManager.searchTerms.claimStatusIds = {}


  }, [orgId])

  const handleSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(search);
    filterObj.currentPage = 1;

    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }
    claimsManager.search.currentPage = 1;

    await fetchClaimList(filterObj);
    setcolumnFilters(columnFilters);
  };
  const fetchPatientmaplist = async (rowdata) => {
    setLoading(true);
    let clamid = rowdata.claimID;
    let patientFrstName = rowdata.patientFirstName;
    let patientLstName = rowdata.patientLastName;
    let patientDB = rowdata.patientDOB;
    try {
      const { data } = await API.post(
        `/${tenantID}/Claim/UnMappedPatientData/${clamid}/${patientFrstName}/${patientLstName}/${patientDB}`
      );
      if (data) {
        setPatientTableData(data);
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };

  const isProviderEmpty = async (value) => {
    setIsPEmpty(value);
  }

  const isPatientEmpty = async (value) => {
    setIspatntEmpty(value)
  }
  // console.log(patientId,"coveredentity")

  return (
    <div>
      {loading && <Loader opacity={0.01} color='black' />}

      <Container fluid className="width_info">
        {showpatientdetails == false &&
          <>
            <div className={collapseSider ? "mb-0" : "mb-3"}>
              <Card className="border-0 shadow-top">
                <CardBody className="" hidden={collapseSider}>
                  <ErrorBoundary>
                    <SearchContainer
                      onReset={handleReset}
                      filters={search}
                      onManualSearch={onManualSearch}
                      onSearch={handleSearch}
                      onManualbulkUpdate={onManualbulkUpdate}
                      orgId={orgId}
                      isProviderEmpty={isProviderEmpty}
                      isPatientEmpty={isPatientEmpty}
                    />
                  </ErrorBoundary>
                </CardBody>
              </Card>
            </div>
            <Card className="border-0 shadow-top">
              <CardBody className="pt-0">
                <ErrorBoundary>
                  <ClaimsManagerTable
                    module={module}
                    data={data}
                    filters={search}
                    totalSize={totalItem}
                    coveredEntity={coveredEntity}
                    AllExport={handleExport2}
                    refetch={refetch}
                    onPageChange={handlePageChange}
                    onSearchColumnFilters={handleSearchColumnFilters}
                    manvalPatient={manvalPatient}
                    collapseSider={collapseSider}
                    toggleSider={toggleSider}
                    onManualbulkUpdate={onManualbulkUpdate}
                    orgId={orgId}
                    showpatientdetails={showpatientdetails}
                    setShowPatientDetails={setShowPatientDetails}
                    patientIDNAME={patientIDNAME}
                    resetFlag={resetFlag}
                    SetResetFlag={SetResetFlag}
                    setPatientIdName={setPatientIdName}
                  />
                </ErrorBoundary>
              </CardBody>
            </Card>
          </>
        }
        {showpatientdetails == true &&
          <Patient orgId={orgId}
            refetch={refetch}
            module={module}
            coveredEntity={coveredEntity?.coveredEntityID}
            tenantID={coveredEntity?.tenantID}
            isfax={"true"}
            patientIDNAME={patientIDNAME}
            showpatientdetails={showpatientdetails}
            setShowPatientDetails={setShowPatientDetails}


          />
        }
      </Container>

      <Drawer
        direction="end"
        title="Auto-Approve Provider & Patient Combinations"
        isOpen={isOpenProgram}
        toggle={onHandleManualProgram}
        size="lg"
      >
        <PatientProviderMap
          //  hasEditable={true}
          onClose={onHandleManualProgram}
          selectedCoveredEntity={coveredEntity}
        />
      </Drawer>
      <Drawer
        direction="end"
        isOpen={bulkupdate}
        toggle={toggleBulkUpdate}
        title="Bulk Update"
        size="lg"
      >
        <BulkUpdateClaims
          data={tableData}
          statusList={statusList}
          refetchBulkData={fetchBulkData}
          setBulkUpdate={setBulkUpdate}
          refetch={refetch}
          loader={loader}
        />
      </Drawer>
      <Drawer
        direction="end"
        isOpen={openPatient}
        toggle={togglepatient}
        title="Patient Details"
        size="lg"
      >
        <PatientNotFound
          coveredEntityID={searchTerms.coveredEntityID}
          tenantID={tenantID}
          patientTableData={patientTableData}
          patientdata={patientdata}
          fetchPatientmaplist={fetchPatientmaplist}
          loading={loading}
          setLoading={setLoading}
          togglepatient={togglepatient}
          refetch={refetch}
        />
      </Drawer>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default ClaimManager;
